import React, {useContext} from 'react'
import { useNavigate } from 'react-router-dom'
import { BodyContext } from '../../contexts/BodyProvider'
import styles from "./headerAdmin.module.css"

type Props = {
  user: UserRouter | undefined
}

const HeaderAdimn = ({user}: Props) => {
  const {
    adminButtonBIValues,
    adminButtonValues
  } =  useContext(BodyContext)

  let navigate = useNavigate()
  const handleAdminNavigate = () => {
    navigate("/")
  }

  const handleShowCards = () => {
    adminButtonBIValues?.setShowCardBIAdmin(false)
    adminButtonValues?.setShowCardAdmin(true)
  }
  const handleShowCardsBI = () => {
    adminButtonBIValues?.setShowCardBIAdmin(true)
    adminButtonValues?.setShowCardAdmin(false)
  }
  return (
    <>
      <div className={styles.headerContainer}>
        <div className={styles.headerInnerAdmin}>
            <div className={styles.headerTitle}>
              <div>
                <h5>Conecta</h5>
              </div>
              <div>
                <ul>
                  <li onClick={handleAdminNavigate}>Voltar</li>
                  {user?.userRole === "3" ? 
                    (
                      <>
                      <li onClick={handleShowCards}>Admin</li>
                      <li onClick={handleShowCardsBI}>Admin-BI</li>
                      </>
                    )
                    : null
                  }
                  
                </ul>
              </div>
            </div>
            <div>
                <span>{user?.userName}</span>
                <i className="bi bi-box-arrow-in-right"
                  style={{fontSize: "1.2rem", color:"#545454"}}
                  onClick={handleAdminNavigate}
                ></i>
            </div>
        </div>
    </div>
    </>
    
  )
}

export default HeaderAdimn